import { render, staticRenderFns } from "./LoudMain.vue?vue&type=template&id=561d35e5&scoped=true"
import script from "./LoudMain.vue?vue&type=script&lang=js"
export * from "./LoudMain.vue?vue&type=script&lang=js"
import style0 from "./LoudMain.vue?vue&type=style&index=0&id=561d35e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d35e5",
  null
  
)

export default component.exports